import {React,useState} from 'react'
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

function Payment(props) {



  const [paidFor, setPaidFor] = useState(false);
  const [error, setError] = useState(null);
  const handleApprove = (orderId) => {
    // Call backend function to fulfill order

    // if response is success
    setPaidFor(true);
    // Refresh user's account or subscription status

    // if response is error
    // alert("Your payment was processed successfully. However, we are unable to fulfill your purchase. Please contact us at support@designcode.io for assistance.");
  };

  if (paidFor) {
    // Display success message, modal or redirect user to success page
    alert("Thank you for your purchase!");
  }
  if (error) {
    // Display error message, modal or redirect user to error page
    alert(error);
  }
  

    const initialOptions = {
        clientId: "AWUxpJBlSe7sQl_LnCJPe5FzlscBH1r-EU75CNlUJFKDKomUBKXdIYdVZd0fy7oafVstnbLBWoSpu56G",
        currency: "USD",
        intent: "capture",
    };
   
   
        return (
            <PayPalScriptProvider options={initialOptions}>
                <PayPalButtons 
                
                createOrder={(data, actions) => {
                    return actions.order.create({
                      purchase_units: [
                        {
                          description: 'order from website',
                          amount: {
                            value: 10
                          }
                        }
                      ]
                    });
                  }}

                  onApprove={async (data, actions) => {
                    const order = await actions.order.capture(); 
                    console.log("order", order);
                  
                    handleApprove(data.orderID);
                  }}

                  onError={(err) => {
                    setError(err);
                    console.error("PayPal Checkout onError", err);
                  }}
                />


            </PayPalScriptProvider>
        );
}

export default Payment
